import { HttpClient, HttpHeaders, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { constant } from "../app.constants";
import { CommonStore } from "../store";
import { CommonService } from "./common.service";
import { StorageService } from "./storage.service";
import { fabric } from "fabric";

const reqOptns = {
    headers: new HttpHeaders().set("isLoadNotReq", "true")
};

@Injectable()
export class LabelDesignService {

    constructor(private _http: HttpClient, private _cmnstr: CommonStore, private _cmnSvc: CommonService, private _storageSvc: StorageService) { }

    getLabels(): Observable<any> {
        return this._http.get<any>(constant.GET_Labels);
    }

    getLabelsData(data) {
        return this._http.post<any>(constant.GET_Labels,data);
    }
    getTemplateAndRxNumber(addHdrs?:boolean) {
        if (addHdrs) {
            return this._http.get<any>(constant.GET_TempAndRx, reqOptns);
        } else {
            return this._http.get<any>(constant.GET_TempAndRx);
        }
        
    }

    postDefaultReturnToStock(data) {
        return this._http.post<any>(constant.POST_LabelDesigner_DefaultReturnToStock.replace(
                "{TemplateId}",
                data
            ),null);
    }

    getLabelTemplateById(templateId) {
        return this._http.get<any>(constant.GET_TemplateById
            .replace("{templateId}", templateId + "")
        );
    }
    postTemplet(addTemplate: any): Observable<any> {
        return this._http.post<any>(constant.POST_Template, addTemplate);
    }
    updateTemplet(updateTemp: any) {
        return this._http.put(constant.UPDATE_Template, updateTemp);
    }
    sigValuesSplit(stringToJson2,labelData) {
        let remainingDescription = null;
        let remainingAltDescription = null;
        let stringToJsonRemaing = null;
        let stringToJsonExtRemaining = null;
        let hasExtendedNodes = false;
        let ExtSigDescValues = null;
        let iterationCountForAltSig = null;
        let iterationCountForSig = null;
        let isDescOnSecondPage = false;
        if (labelData && labelData?.SecondPageDesignParams) 
            stringToJsonRemaing = JSON?.parse(labelData?.SecondPageDesignParams)
        if (labelData && labelData?.ExtendedSigSecondPageDesignParams) 
            stringToJsonExtRemaining = JSON?.parse(labelData?.ExtendedSigSecondPageDesignParams)
        if (labelData && labelData.SigDescription && stringToJson2?.objects?.find(obj => obj.type === 'textbox' && obj.text === '{ Ext_SigCodes_Description }')) {
            hasExtendedNodes = true;
            const cleanedSigDescription = labelData?.SigDescription?.replace(/\n/g, '');
            let sigDescObj = stringToJson2?.objects?.find(obj => obj.type === 'textbox' && obj.text === '{ Ext_SigCodes_Description }')
            stringToJsonExtRemaining.objects[0] =  JSON.parse(JSON.stringify(sigDescObj))
            ExtSigDescValues = {
                fontFamily: sigDescObj?.fontFamily || 'arial',
                fontSize: +sigDescObj?.fontSize || 36,
                lineHeight: +sigDescObj?.lineHeight || 1.16,
                width: +sigDescObj?.width || 600,
                height: +sigDescObj?.height || 40.68,
                text: cleanedSigDescription,
                top: sigDescObj?.top,
                left: sigDescObj?.left
            };
            const { firstPart, remainingPart } = this.splitTextForFabric(ExtSigDescValues, sigDescObj?.text);
            if (remainingPart) {
                remainingDescription = true;
                ExtSigDescValues.text = remainingPart;
                iterationCountForSig = this.splitTextCount(ExtSigDescValues, 1);

            }
            sigDescObj.text = firstPart;
            sigDescObj.scaleY = 1;
            if (stringToJsonExtRemaining) {
                let matchingSecondPageObj = stringToJsonExtRemaining?.objects?.find(
                    obj => obj.type === 'textbox' && obj.text === '{ Ext_SigCodes_Description }'
                );
                if (matchingSecondPageObj && remainingPart) {
                    isDescOnSecondPage = true;
                    matchingSecondPageObj.text = `Rx# :${labelData?.PrescNum} Refill# : ${labelData?.RefillNum}\n\n ${remainingPart}`;
                    matchingSecondPageObj.scaleY = 1;
                }
            }
        }
        if (labelData && labelData.SigDescription) {
            const cleanedSigDescription = labelData?.SigDescription?.replace(/\n/g, '');
            stringToJson2?.objects
                ?.filter(obj => obj.type === 'textbox' && obj.text === '{ SigCodes_Description }')
                ?.forEach(sigDescObj => {
                const sigDescValues = {
                    fontFamily: sigDescObj?.fontFamily || 'arial',
                    fontSize: +sigDescObj?.fontSize || 36,
                    lineHeight: +sigDescObj?.lineHeight || 1.16,
                    width: +sigDescObj?.width || 600,
                    height: +sigDescObj?.height || 40.68,
                    text: cleanedSigDescription,
                };
                const { firstPart, remainingPart } = this.splitTextForFabric(sigDescValues, sigDescObj?.text);
                if (remainingPart) {
                    remainingDescription = true;
                }
                sigDescObj.text = firstPart;
                sigDescObj.scaleY = 1;
                if (stringToJsonRemaing) {
                    const matchingSecondPageObj = stringToJsonRemaing?.objects?.find(
                    obj => obj.type === 'textbox' && obj.text === '{ SigCodes_Description }'
                );
                if (matchingSecondPageObj && remainingPart) {
                    matchingSecondPageObj.text = remainingPart;
                    matchingSecondPageObj.scaleY = 1;
                }
                }
            });
            stringToJsonRemaing?.objects
                ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_Description }')
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
            stringToJsonExtRemaining?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_Description }' || obj?.text === '{ Ext_SigCodes_Description }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
        } else {
             stringToJson2?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_Description }' || obj?.text === '{ Ext_SigCodes_Description }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
             })
            stringToJsonRemaing?.objects
                ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_Description }')
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
            stringToJsonExtRemaining?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_Description }' || obj?.text === '{ Ext_SigCodes_Description }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
        }
        if (labelData && labelData?.AltSigDescription && stringToJson2?.objects?.find(obj => obj.type === 'textbox' && obj.text === '{ Ext_SigCodes_AlternateLangDescription }')) {
            const cleanedAltSigDescription = labelData.AltSigDescription.replace(/\n/g, '');
            let altLangObj = stringToJson2?.objects?.find(obj => obj?.type === 'textbox' && obj?.text === '{ Ext_SigCodes_AlternateLangDescription }')
            stringToJsonExtRemaining.objects[1] =  JSON.parse(JSON.stringify(altLangObj))
            hasExtendedNodes = true;
            const altLangValues = {
                fontFamily: altLangObj?.fontFamily || 'arial',
                fontSize: +altLangObj?.fontSize || 36,
                lineHeight: +altLangObj?.lineHeight || 1.16,
                width: +altLangObj?.width || 600,
                height: +altLangObj?.height || 40.68,
                text: cleanedAltSigDescription,
                top: altLangObj?.top,
                left: altLangObj?.left
            };
            const { AlterSigfirstPart, AlterSigRemainingPart } = this.splitTextForFabric(altLangValues, altLangObj?.text);
            if (AlterSigRemainingPart) {
                iterationCountForAltSig = this.splitTextCount(altLangValues, 1);
                remainingAltDescription = true;
            }
            altLangObj.text = AlterSigfirstPart;
            altLangObj.scaleY = 1;
            if (stringToJsonExtRemaining) {
                const matchingSecondPageObj = stringToJsonExtRemaining?.objects?.find(
                obj => obj?.type === 'textbox' && obj?.text === '{ Ext_SigCodes_AlternateLangDescription }' 
                );
                if (matchingSecondPageObj) {
                    let isOverlap = false;
                    // Check if two rectangles overlap
                    const box1Right = ExtSigDescValues?.left + ExtSigDescValues?.width;
                    const box1Bottom = ExtSigDescValues?.top + (ExtSigDescValues?.height * (iterationCountForSig <= 2 ? iterationCountForSig + 1 : iterationCountForSig));
                    const box2Right = matchingSecondPageObj?.left + matchingSecondPageObj?.width;
                    const box2Bottom = matchingSecondPageObj?.top + (matchingSecondPageObj?.height * (iterationCountForAltSig <= 2 ? iterationCountForAltSig + 1 : iterationCountForAltSig));

                    if (ExtSigDescValues && !(box1Right <= matchingSecondPageObj?.left ||
                        box2Right <= ExtSigDescValues?.left ||
                        box1Bottom <= matchingSecondPageObj?.top ||
                        box2Bottom <= ExtSigDescValues?.top)) {
                            console.log("Overlap detected between two boxes");
                            isOverlap = true;
                    } else {
                        isOverlap = false;
                        console.log("No overlap detected between two boxes");
                    }
                    if (matchingSecondPageObj?.top <= ExtSigDescValues?.top && isOverlap) {
                        isOverlap = false;
                        stringToJsonExtRemaining.objects[0].top = ExtSigDescValues?.top + (matchingSecondPageObj?.height * (iterationCountForAltSig > 1 ? iterationCountForAltSig - 1 : 1));
                    }
                    matchingSecondPageObj.top = isOverlap ? matchingSecondPageObj?.top + (ExtSigDescValues?.height * (ExtSigDescValues?.height < 60 ? iterationCountForSig + 3 : iterationCountForSig)) : matchingSecondPageObj?.top;
                    matchingSecondPageObj.text = isDescOnSecondPage ? AlterSigRemainingPart : `Rx# :${labelData?.PrescNum} Refill# : ${labelData?.RefillNum}\n\n ${AlterSigRemainingPart}`;
                    matchingSecondPageObj.scaleY = 1;
                }
            }
            stringToJsonExtRemaining?.objects
                ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ Ext_SigCodes_AlternateLangDescription }')
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
        }
        if (labelData && labelData?.AltSigDescription) {
            const cleanedAltSigDescription = labelData.AltSigDescription.replace(/\n/g, '');
            stringToJson2?.objects
            ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_AlternateLangDescription }')
            ?.forEach(altLangObj => {
                const altLangValues = {
                    fontFamily: altLangObj?.fontFamily || 'arial',
                    fontSize: +altLangObj?.fontSize || 36,
                    lineHeight: +altLangObj?.lineHeight || 1.16,
                    width: +altLangObj?.width || 600,
                    height: +altLangObj?.height || 40.68,
                    text: cleanedAltSigDescription,
                };
                const { AlterSigfirstPart, AlterSigRemainingPart } = this.splitTextForFabric(altLangValues, altLangObj?.text);
                if (AlterSigRemainingPart) {
                    remainingAltDescription = true;
                }
                altLangObj.text = AlterSigfirstPart;
                altLangObj.scaleY = 1;
                if (stringToJsonRemaing) {
                     const matchingSecondPageObj = stringToJsonRemaing?.objects?.find(
                    obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_AlternateLangDescription }'
                );
                if (matchingSecondPageObj) {
                    matchingSecondPageObj.text = AlterSigRemainingPart;
                    matchingSecondPageObj.scaleY = 1;
                }
                }
            });
            stringToJsonRemaing?.objects
                ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_AlternateLangDescription }')
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
             })
            stringToJsonExtRemaining?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_AlternateLangDescription }' || obj?.text === '{ Ext_SigCodes_AlternateLangDescription }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
        } else {
            stringToJson2?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_AlternateLangDescription }' || obj?.text === '{ Ext_SigCodes_AlternateLangDescription }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
             })
            stringToJsonRemaing?.objects
                ?.filter(obj => obj?.type === 'textbox' && obj?.text === '{ SigCodes_AlternateLangDescription }')
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })
            stringToJsonExtRemaining?.objects
                ?.filter(obj => obj?.type === 'textbox' && (obj?.text === '{ SigCodes_AlternateLangDescription }' || obj?.text === '{ Ext_SigCodes_AlternateLangDescription }'))
                ?.forEach(sigAlterLangObj => {
                    sigAlterLangObj.text = '';
            })

        }
        const firstJSON = JSON?.stringify(stringToJson2);
        const secondJSON = JSON?.stringify(hasExtendedNodes ? stringToJsonExtRemaining : stringToJsonRemaing);
        return {firstJSON, secondJSON, remainingDescription, remainingAltDescription}
    }

    splitTextForFabric(sigDescValues,labelFieName) {
        const tempText = new fabric.Textbox(sigDescValues.text, {
            fontFamily: sigDescValues?.fontFamily,
            fontSize: sigDescValues?.fontSize,
            lineHeight: sigDescValues?.lineHeight,
            width: sigDescValues?.width,
        });
        const actualTextLines = (tempText as any).textLines;
        let firstPartLines = [];
        let currentHeight = 0;
        const effectiveLineHeight = tempText?.lineHeight * sigDescValues?.fontSize * 1.025
        for (let i = 0; i < actualTextLines?.length; i++) {
            if (currentHeight + effectiveLineHeight < sigDescValues?.height * 1.055) {
                firstPartLines.push(actualTextLines[i]);
                currentHeight += effectiveLineHeight;
            } else {
                break;
            }
        }
        let remainingLines = actualTextLines?.slice(firstPartLines?.length);
            if (remainingLines && remainingLines.length) {
                const lastLineIndex = firstPartLines?.length - 1;
                const lastLine = firstPartLines?.[lastLineIndex];
                const words = lastLine?.trim()?.split(' ');
                const lastWord = words?.pop();
                words?.push('...');
                firstPartLines[lastLineIndex] = words?.join(' ');
                if (firstPartLines && !firstPartLines.length) {
                    firstPartLines = ["..."]
                } else {
                    remainingLines = [lastWord, ...actualTextLines?.slice(firstPartLines?.length)];
                }
            }
        if (labelFieName == "{ SigCodes_AlternateLangDescription }" || labelFieName == "{ Ext_SigCodes_AlternateLangDescription }") {
            const AlterSigfirstPart = firstPartLines?.join(' ');
            const AlterSigRemainingPart = remainingLines?.join(' ');
            return { AlterSigfirstPart,AlterSigRemainingPart };
        } else {
            const firstPart = firstPartLines?.join(' ');
            const remainingPart = remainingLines?.join(' ');
            return { firstPart,remainingPart };
        }
    }

    splitTextCount(sigDescValues,count) {
        const tempText = new fabric.Textbox(sigDescValues.text, {
            fontFamily: sigDescValues?.fontFamily,
            fontSize: sigDescValues?.fontSize,
            lineHeight: sigDescValues?.lineHeight,
            width: sigDescValues?.width,
        });
        const actualTextLines = (tempText as any).textLines;
        let firstPartLines = [];
        let currentHeight = 0;
        const effectiveLineHeight = tempText?.lineHeight * sigDescValues?.fontSize * 1.025
        for (let i = 0; i < actualTextLines?.length; i++) {
            if (currentHeight + effectiveLineHeight < sigDescValues?.height * 1.055) {
                firstPartLines.push(actualTextLines[i]);
                currentHeight += effectiveLineHeight;
            } else {
                break;
            }
        }
        let remainingLines = actualTextLines?.slice(firstPartLines?.length);
        if (remainingLines && remainingLines.length && firstPartLines?.length) {
            count = count + 1;
            sigDescValues.text = remainingLines?.join(' ');
            return this.splitTextCount(sigDescValues,count)
        } else {
            return remainingLines && remainingLines?.length ? count + remainingLines.length : count;
        }
    }

    templateDelete(template: any) {
        return this._http.delete(
            constant.DELETE_Template.replace(
                "{TemplateId}",
                "" + template
            )
        );
    }

    preview(prescId: any, PrescNum: any, templateId: any, prescrefillId?: any, printCoun?: any, isShrtCoun?: any, 
        printCummlative?: any, isFrmDpvVerf?: any, DispQty?: any, DrugId?: any, OweQty? : any,iouOrder?: any, dpvForUnbilledSetting? :any, IsFromRecallDeletedRx?, IsPrescnumExists?) {
        let SfaxEncryptionVector = this._cmnSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        const InterfaceSet = this._cmnstr.interfacePharmConfigSetting$["source"]["value"];
        const configDet = InterfaceSet && InterfaceSet.length ? InterfaceSet[0].configurationDetail : null;
        const actvList = configDet && configDet.sendData && configDet.sendData.length ? configDet.sendData.filter((item: any) => item.active) : null;
        const actvEyeconList = actvList?.length ? actvList.filter((item: any) => item.interfaceId === "1") : null;
        const actvVividList = actvList?.length ? actvList.filter((item: any) => item.interfaceId === "2") : null;
        // const ipAddress = this.getIPAddress();
        // console.log(ipAddress, "ipAddress");
        if (this._storageSvc.getLocalStorage("GUIDEyecon") && this._cmnSvc.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector) && actvList?.length) {
            const eyconDet = actvList.find((machnDet: any) => ((machnDet.guid === (this._cmnSvc.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector))) && machnDet.receiveMode === "I"))
            this._cmnSvc.setEncryptLocalStorage("ImmediateOrPopMode", (eyconDet ? "true" : "false"), SfaxEncryptionVector)
        }
        const flagVividEnabled = this._cmnSvc.getSetttingValue("RxSettings", "IS_VIVID_ENABLED") === "1"; 
        // const flagVividEnabled = false;
        const obj = {id: prescId, prescNum: PrescNum, templateId: templateId,
             isShortMonogramSelected: isShrtCoun ? isShrtCoun : false, printCounsellingsheet: printCoun ? printCoun : false,
             prescrefillId: prescrefillId, printCumlative: printCummlative ? printCummlative : false, IsEyeConEnabled: (actvEyeconList && actvEyeconList.length ? true : false), IsVividEnabled: (flagVividEnabled && actvVividList && actvVividList.length ? true : false), MACAddress: null, ReceiveMode: localStorage.getItem("ImmediateOrPopMode") && (this._cmnSvc.getDecryptLocalStorage("ImmediateOrPopMode", false, SfaxEncryptionVector)  === "true") ? "I" : "B",
             isFrmDpvVerf : isFrmDpvVerf ? isFrmDpvVerf : false, DispQty : DispQty ? DispQty : null, DrugId : DrugId ? DrugId : null, OweQty : OweQty ? OweQty : null, iouOrder : iouOrder ? iouOrder : null,
             dpvForUnbilledSetting: dpvForUnbilledSetting ? dpvForUnbilledSetting : null, IsFromRecallDeletedRx: IsFromRecallDeletedRx ? IsFromRecallDeletedRx : null, IsPrescnumExists: IsPrescnumExists ? IsPrescnumExists : null, IsVividFlagEnabled: flagVividEnabled}
        return this._http.post<any>(constant.GET_PreviewLabels, obj);
    }
    // getIPAddress() {
    //     let result: any;
    //     fetch(environment.ipAddressUrl)
    //     .then((response) => response.json())
    //     .then((data) => {
    //       result = data.ip;
    //     })
    //     .catch((error) => {
    //       console.error('Error fetching IP address:', error);
    //     });
    //     return result;
    // }
    previewForLabelDocuemnts(prescId: any, PrescNum: any, templateId: any, prescrefillId?: any, printCoun?: any, isShrtCoun?: any, printCummlative?: any) {
        const obj = {id: prescId, prescNum: PrescNum, templateId: templateId,
             isShortMonogramSelected: isShrtCoun ? isShrtCoun : false, printCounsellingsheet: printCoun ? printCoun : false,
             prescrefillId: prescrefillId, printCumlative: printCummlative ? printCummlative : false};
        return this._http.post<any>(constant.GET_Reports_LabelDocuments, obj);
    }
    getCompoundFormPrint(drugId: any, prescRefillId: any, isFrmCompDrugPrint : boolean = false): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set("Accept", "application/pdf");
        headers = headers.set("isLoadNotReq", "true");
        return this._http.get(constant.GET_Compound_Formulation
            .replace("{drugId}", "" + drugId)
            .replace("{prescRefillId}", "" + prescRefillId)
            .replace("{isFrmCompDrugPrint}", "" + isFrmCompDrugPrint),
            { headers: headers, responseType: "blob" }
        );
    }

    getIsCounsellingPrinted(payload): Observable<any> {
        return this._http.post<any>(constant.POST_IsMonogram_Printed, payload);
    }

    getCounsellingReport(payload) {
        let headers = new HttpHeaders();
        headers = headers.set("content-type", "application/json");
        headers = headers.set("Accept", "application/pdf");
        headers = headers.set("isLoadNotReq", "true");
        return this._http.post(constant.POST_Print_Drug_Counselling, payload,{ headers: headers, responseType: "blob" });
    }

    postCounsellingAudit(payload) {
        return this._http.post(constant.POST_Print_Counselling_Audit, payload);
    }

    postPCAutomatLabelCheck(payload) {
        return this._http.post(constant.POST_Automated_PrintCheck, payload);
    }

    previewForMultipleLabelPrint(payload){
        return this._http.post(constant.POST_Bulk_Label_Preview, payload);
    }

    auditLogForMultipleLabels(auditLogData) {
        return this._http.post(constant.POST_BulkSave_LabelLogs, auditLogData)
    }

    getQzTryVersionWithProgress(payload?: any): Observable<HttpEvent<Blob>> {
        return this._http.post(constant.GET_QZTray_Latest_Version, payload ?? {},  {
            responseType: 'blob',
            observe: 'events',
            reportProgress: true,
            headers: new HttpHeaders().set("isLoadNotReq", "true")
        });
    }

    getQzTryLatestVersion(payload?: any): Observable<any> {
        return this._http.post(constant.GET_QZTray_Latest_Version_Number, payload ?? {} );
    }
}
